import React from 'react';

const Logo = ({ className = "", width = 180, height = 50 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 180 50" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield Background */}
      <path
        d="M15 5C15 5 10 7 10 12V25C10 32 15 37 20 40C25 37 30 32 30 25V12C30 7 25 5 25 5C25 5 22.5 6 20 6C17.5 6 15 5 15 5Z"
        fill="#8FEC78"
        opacity="0.2"
      />
      
      {/* Shield Outline */}
      <path
        d="M20 6C17.5 6 15 5 15 5C15 5 10 7 10 12V25C10 32 15 37 20 40C25 37 30 32 30 25V12C30 7 25 5 25 5C25 5 22.5 6 20 6Z"
        stroke="#0D7916"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Leaf Icon inside shield */}
      <path
        d="M20 15C20 15 16 16 16 20C16 24 20 28 20 28C20 28 24 24 24 20C24 16 20 15 20 15Z"
        fill="#0D7916"
      />
      <path
        d="M20 15L20 28"
        stroke="#8FEC78"
        strokeWidth="1"
        strokeLinecap="round"
      />
      
      {/* Text: NY PEST */}
      <text
        x="42"
        y="25"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize="20"
        fontWeight="700"
        fill="#003720"
        letterSpacing="-0.5"
      >
        NY PEST
      </text>
      
      {/* Text: & Exterminating */}
      <text
        x="42"
        y="40"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize="11"
        fontWeight="500"
        fill="#83928c"
        letterSpacing="0.5"
      >
        & EXTERMINATING
      </text>
    </svg>
  );
};

export default Logo;
